export default __webpack_public_path__ + "static/media/symbol01.ae9932ce.svg";